import React from 'react';
import GenericSetupPage from './GenericSetupPage';

const ReasonNotAdmittedPage = () => {
  const columns = [
    { key: 'code', label: 'Code' },
    { key: 'reason', label: 'Reason' },
    { key: 'description', label: 'Description' },
    { key: 'active', label: 'Active' },
  ];

  const formFields = [
    { key: 'code', label: 'Code', type: 'text', required: true },
    { key: 'reason', label: 'Reason', type: 'text', required: true },
    { key: 'description', label: 'Description', type: 'textarea', required: false, fullWidth: true },
    { key: 'active', label: 'Active', type: 'select', required: true, options: [
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' }
    ]}
  ];

  const initialData = [
    { id: '1', code: 'INELIG', reason: 'Insurance Ineligible', description: 'Patient does not meet insurance eligibility requirements', active: 'Yes' },
    { id: '2', code: 'NOHB', reason: 'No Homebound Status', description: 'Patient does not meet homebound criteria', active: 'Yes' },
    { id: '3', code: 'REFUSED', reason: 'Patient Refused', description: 'Patient declined home health services', active: 'Yes' },
    { id: '4', code: 'NOAUTH', reason: 'Authorization Denied', description: 'Payer denied authorization for services', active: 'Yes' },
    { id: '5', code: 'NOMD', reason: 'No Physician Order', description: 'Unable to obtain physician order for services', active: 'Yes' },
    { id: '6', code: 'OUTAREA', reason: 'Out of Service Area', description: 'Patient resides outside agency service area', active: 'Yes' },
    { id: '7', code: 'NOSN', reason: 'No Skilled Need', description: 'Patient does not require skilled services', active: 'Yes' },
    { id: '8', code: 'HOSP', reason: 'Hospitalized', description: 'Patient was hospitalized before admission', active: 'Yes' },
    { id: '9', code: 'DECEASED', reason: 'Patient Deceased', description: 'Patient passed away before admission', active: 'Yes' },
    { id: '10', code: 'OTHER', reason: 'Other', description: 'Other reason (see notes)', active: 'Yes' },
  ];

  return (
    <GenericSetupPage
      title="Reason Not Admitted"
      columns={columns}
      initialData={initialData}
      addButtonText="Add Reason"
      formFields={formFields}
      apiEndpoint="/setup/reason-not-admitted"
    />
  );
};

export default ReasonNotAdmittedPage;
